import { ReactQuery } from '@codeleap/query'
import { QueryKeys } from './queryKeys'
import { retrieve } from './views'
import { Profile } from '@packages/types'
import '../queryClient'
import { Chat } from '@/config'
import { useChatUserImage } from '@packages/chat/src'

type UseProfileOptions = Partial<ReactQuery.UseQueryOptions<Profile>>

export function useProfile(options?: UseProfileOptions) {
  const query = ReactQuery.useQuery({
    queryKey: QueryKeys.me.key,
    queryFn: retrieve,
    refetchOnMount: 'always',
    ...options,
    enabled: options?.enabled || false,
  })

  const chatUser = Chat.Store.useUser()
  const avatar = useChatUserImage(chatUser?.id, chatUser?.image)
  const profile = query?.data ? { ...query?.data, avatar } as Profile : null

  return {
    ...query,
    data: profile,
    profile,
    isLoggedIn: !!query.data?.id,
  }
}
